import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxHttpClientExtraOptions } from 'ngx-httpclient';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServicesTokenService {

  headerConfig: NgxHttpClientExtraOptions = {
    headers: new HttpHeaders()
      .append('Content-Type', 'application/x-www-form-urlencoded')
  };
  authToken = new BehaviorSubject<string>(null);
  /**
   * @description constructor
   */
  constructor() {
  }
  /**
   * @description recuperara cabecera
   */
  getHeaders(): NgxHttpClientExtraOptions {
    return this.headerConfig;
  }
}
